module.exports = __webpack_public_path__ + "static/media/rapidovideo.b142e6aa.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/rapidovideo.mp4
// module id = 530
// module chunks = 0